import { PreviewWorksheet } from "@features/upload/FileContentPreviewTable"
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"

type WorksheetPreviewProps = {
  worksheet: PreviewWorksheet
}

const WorksheetPreview = (props: WorksheetPreviewProps) => {
  return (
    <>
      {props.worksheet.tables.map((table, i) => (
        <div key={i}>
          {table.rows.length > 0 && (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {Object.keys(table.rows?.[0] ?? {}).map((value, i) => (
                      <TableCell key={i}>
                        <strong>{value}</strong>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {table.rows.map((row, i) => (
                    <TableRow key={i}>
                      {Object.values(row).map((cell, j) => (
                        <TableCell key={j}>{cell.toString()}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      ))}
    </>
  )
}

export default WorksheetPreview
